import script from "./LeadsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeadsForm.vue?vue&type=script&setup=true&lang=ts"

import "./LeadsForm.vue?vue&type=style&index=0&id=1b1d6e53&lang=scss"

const __exports__ = script;

export default __exports__